export default "__VITE_ASSET__ff2daab5__"